import axios from 'axios';
import csrfHeaders from '../../utils/csrfHeaders';
import { formatDateTimeWithoutSeconds } from '../../util/helpers/dateHelpers';

// ENG-3659: "Awaiting Provider" sets a referral aside while its referring
// provider is added to NextGen; the nightly sync brings the provider in and the
// user files it from the Awaiting Provider filter. The hold drops off once the
// document is filed. It exists only for organizations with a NextGen
// connection that has provider requests configured (ENG-3658).
export const AWAITING_PROVIDER_LABEL = 'Awaiting Provider';
export const AWAITING_PROVIDER_FILTER_KEY = 'awaitingProvider';
const HOLD_PATH = '/api/v1/awaiting_provider_hold';
// The documents Send to Chart files from; holds are only offered on these.
// Receiver: a document another Medsender user sent (ENG-3825).
const HOLDABLE_PARENT_TYPES = ['ReceivedFax', 'EmailAttachment', 'Receiver'];

// Holds are for documents the organization received. The Sent page opens the
// same drawer on its outgoing Receiver rows, which the sender can't hold (the
// server answers 404), so it never offers marking.
export const canHoldDocument = (parentType, sendToken, { sentContext = false } = {}) => (
  !sentContext && HOLDABLE_PARENT_TYPES.includes(parentType) && Boolean(sendToken)
);

// Resolves to the hold, { marked_at, marked_by }. `form` is the Send to Chart
// form as the user left it, which the server requires complete except for the
// referring provider (ENG-3934); `requestedProvider` ({ npi, first_name,
// last_name }) is the provider asked for. Sending again for a document that is
// already held updates both.
export const placeAwaitingProviderHold = ({
  parentType, sendToken, form, requestedProvider,
}) => axios.post(
  HOLD_PATH,
  {
    parent_type: parentType,
    send_token: sendToken,
    form,
    ...(requestedProvider && { requested_provider: requestedProvider }),
  },
  { headers: csrfHeaders() },
).then((response) => response.data?.awaiting_provider || null);

export const removeAwaitingProviderHold = ({ parentType, sendToken }) => axios.delete(HOLD_PATH, {
  data: { parent_type: parentType, send_token: sendToken },
  headers: csrfHeaders(),
});

// "Oct 15, 2026, 9:14 AM", or null for a missing or malformed time.
export const formatHeldSince = (markedAt) => {
  if (!markedAt) return null;
  const parsed = new Date(markedAt);
  if (Number.isNaN(parsed.getTime())) return null;
  return formatDateTimeWithoutSeconds(markedAt);
};

export const describeHold = (hold) => {
  const since = formatHeldSince(hold?.marked_at);
  const by = hold?.marked_by ? ` by ${hold.marked_by}` : '';
  return since ? `Marked${by} on ${since}.` : `Marked${by}.`;
};
